export default __webpack_public_path__ + "static/media/filling_10.937f0196.webp";